import classNames from 'classnames';
import AspectRatio from 'components/AspectRatio';
import { AspectRatioDimensions } from 'components/AspectRatio/enums';
import BannerCenteredContent from 'components/Banner/BannerCenteredContent';

import { BodyTextProps } from './types';

import useStyles from './styles';

function BodyTextWithCTASkeleton({ imageToRight, carouselLayout, image }: BodyTextProps) {
  const styles = useStyles();

  const bannerClassNames = classNames(styles.grid, {
    'image-from-left': !imageToRight,
    'image-from-right': imageToRight,
    carousel: carouselLayout,
  });

  const contentClassName = classNames(styles.column, 'content', 'content-fallback');
  const imageClassName = classNames(styles.column, 'image');
  const actionClassName = classNames(styles.column, 'action', 'button-fallback');
  return (
    <BannerCenteredContent carouselLayout={carouselLayout} autoDimensions={!carouselLayout}>
      <div className={bannerClassNames} data-testid="BodyTextWithCTASkeleton-test">
        <div className={contentClassName}>
          <h2>
            <i className="skeleton" />
          </h2>
          <i className="skeleton" />
        </div>
        <div className={imageClassName}>
          <AspectRatio
            dimension={{
              xl: AspectRatioDimensions[image?.ratio] || AspectRatioDimensions.Standard,
            }}
          >
            <i className="skeleton" />
          </AspectRatio>
        </div>
        {!carouselLayout && (
          <div className={actionClassName}>
            <i className="skeleton" />
          </div>
        )}
      </div>
    </BannerCenteredContent>
  );
}

export default BodyTextWithCTASkeleton;
